export default __webpack_public_path__ + "static/media/jpg.9d9c5af4.jpg";